<template>
  <div id="contenedor-eliminar-catalogo-tipo-documento">
    <v-card>
      <v-card-title class="secondary--text">
        Eliminar tipo de documento
      </v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar el tipo de documento "{{ tipoDocumentoEliminar.descripcion }}"?
        </span>
      </v-card-text>
      <v-divider class="bkground" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarCatalogoTipoDocumento"
          :disabled="enviandoFormulario"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixCatalogoTiposDocumentos from './mixCatalogoTiposDocumentos';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogoTipoDocumentoEliminar',
  mixins: [mixCatalogoTiposDocumentos],
  props: {
    tipoDocumentoEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },

  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
